import { commonApi } from '@common/utils/baseQuery';

export interface ICurrency {
  id: number;
  code: string;
  title: string;
}

export interface ICountry {
  id: number;
  title: string;
  code: string;
  phoneCode: string;
  phoneLength: string[];
  currencyId: number;
  currencies: ICurrency[];
}

export interface IFetchCountriesResponse {
  countries: ICountry[];
  countryCode: string;
}

export interface ICity {
  id: number;
  name: string;
  regionId: number;
  countryId: number;
  isEnabled: number;
  staffId: number;
  createdAt: number;
  updatedAt?: number;
  deletedAt?: any;
}

interface IFetchCitiesRequest {
  registration: true;
}
interface IFetchCountriesRequest{
  registration?: string;
}

interface ISaveUserCityParams {
  cityId: number;
}

export const locationApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCountries: builder.query<IFetchCountriesResponse, IFetchCountriesRequest | void>({
      query: ({ registration = '' }  = {}) => ({
        url: '/countries',
        params: {
          registration: registration }
      }),
    }),
    fetchCities: builder.query<ICity[], IFetchCitiesRequest | undefined>({
      query: (params) => ({ url: '/cities', params }),
    }),
    saveUserCity: builder.mutation<void, ISaveUserCityParams>({
      query: (body) => ({
        url: '/cities',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useFetchCountriesQuery, useFetchCitiesQuery, useSaveUserCityMutation } = locationApi;
